import { agentActivity } from 'js/src/data/agent-activity/agent-activity-reducers';

export * from 'js/src/data/agent-activity/agent-activity-actions';
export * from 'js/src/data/agent-activity/agent-activity-operations';
export * from 'js/src/data/agent-activity/agent-activity-selectors';
export * from 'js/src/data/agent-activity/agent-activity-types';

export default agentActivity;
